import React, { useState } from "react";
import { userService } from "../../_services";
import { ConfirmDialog } from "../ui/confirm-dialog";
import { Alert, AlertDescription } from "../ui/alert";
import { CheckCircle } from "lucide-react";

/**
 * Delete Referral URL Confirmation Modal
 * Modernized with shadcn Dialog component
 */
function Delete_referral_url_popup({ 
    toggle_Delete_popup, 
    PopupTitle, 
    PopupMessage, 
    ButtonText, 
    URL_Id, 
    URL_Text 
}) {
    const [messageText, setMessageText] = useState(PopupMessage);
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];

            const apidata = await userService.Delete_ReferralURL(URL_Id, URL_Text, userId);

            if (apidata && apidata.length > 0) {
                if (apidata[0].code !== "-1") {
                    setMessageText(apidata[0].message);
                    if (apidata[0].message === "Deleted Successfully") {
                        setIsSuccess(true);
                        // Auto-close after showing success message
                        setTimeout(() => {
                            toggle_Delete_popup({ stopPropagation: () => {}, currentTarget: null });
                        }, 1500);
                    }
                } else {
                    setMessageText(apidata[0].message);
                }
            } else {
                setMessageText('Error! Please try later.');
            }
        } catch (error) {
            setMessageText('Error! Please try later.');
            console.error('Error deleting referral URL:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        toggle_Delete_popup({ stopPropagation: () => {}, currentTarget: null });
    };

    // If success, show success message only
    if (isSuccess) {
        return (
            <ConfirmDialog
                open={true}
                onOpenChange={handleClose}
                title={PopupTitle}
                onConfirm={handleClose}
                confirmText="Close"
                variant="success"
                showIcon={true}
                hideFooter={false}
            >
                <Alert variant="default" className="bg-green-50 border-green-200">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    <AlertDescription className="text-green-800">
                        {messageText}
                    </AlertDescription>
                </Alert>
            </ConfirmDialog>
        );
    }

    return (
        <ConfirmDialog
            open={true}
            onOpenChange={handleClose}
            title={PopupTitle}
            description={messageText}
            onConfirm={handleDelete}
            onCancel={handleClose}
            confirmText={ButtonText || "Delete"}
            cancelText="Cancel"
            variant="destructive"
            loading={loading}
            showIcon={true}
        />
    );
}

export default Delete_referral_url_popup;
